import {
  AppContext,
  getCurrentUserHook,
  useIsAuthorisedHook,
  withErrorBoundary
} from '@nile/components';
import {
  AccountClient,
  GET_APP_PERSONALIZATION,
  useCachedQuery
} from '@nile/graphql';
import { isEqual } from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useCallback, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  defaultProgressState,
  planBasedTasks,
  SubTasksMapList
} from './constants';
import { OnboardingProgressFloaterPortal } from './ProgressWidget';

const OnboardingProgressFloater = (props) => {
  const user = getCurrentUserHook();
  const flags = useFlags();
  const appContext = useContext(AppContext);
  const { planFeatureList, currentProduct } = appContext;
  const SubTasksMap = SubTasksMapList[currentProduct];
  const [completedTasks, setCompletedTasks] = useState();
  let currentPlan;
  if (planFeatureList.TICKETING?.enabled) {
    currentPlan = 'PSA';
    if (planFeatureList.WINDOWS_MANAGEMENT?.enabled) {
      currentPlan = 'PSAANDRMM';
    }
  } else if (planFeatureList.WINDOWS_MANAGEMENT?.enabled) {
    currentPlan = 'RMM';
  }

  const isTrialUser = user?.subscriptionStatus === 'TRIAL';

  const filteredPlanBasedTasks = planBasedTasks?.[currentPlan].filter(
    (task) => {
      if (SubTasksMap[task]?.flag && !flags[SubTasksMap[task]?.flag]) {
        return false;
      }
      return true;
    }
  );

  const getPlanBasedSubTasks = useCallback(
    (subTasks) => {
      return subTasks.filter((sub) => {
        return filteredPlanBasedTasks.includes(sub);
      });
    },
    [currentPlan]
  );

  const { loading } = useCachedQuery(GET_APP_PERSONALIZATION, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        name: 'onBoardingProgressState'
      }
    },
    onCompleted(response) {
      if (response) {
        const res = response?.getAppPersonalization;
        const completedTasksArray = [];
        let progressState = defaultProgressState;
        if (res !== null) {
          progressState = JSON.parse(res.value);
        }
        Object.keys(progressState)
          .filter((step) => typeof progressState[step] === 'object')
          .map((step) => ({
            ...progressState[step],
            id: step
          }))
          .forEach((stepObj) => {
            Object.keys(stepObj).forEach((taskKey) => {
              if (stepObj[taskKey]) {
                completedTasksArray.push(taskKey);
              }
            });
          });
        const completedTasksPlanBased = getPlanBasedSubTasks(
          completedTasksArray
        );
        if (!isEqual(completedTasksPlanBased, completedTasks)) {
          setCompletedTasks(completedTasksPlanBased);
        }
      }
    }
  });

  function redirectToOnboarding() {
    props.history.push(`/productonboard`);
  }

  const percentageComplete =
    Math.floor(
      (completedTasks?.length / filteredPlanBasedTasks.length) * 100
    ) || 0;

  if (
    !useIsAuthorisedHook('adminOnboarding.allow') ||
    percentageComplete === 100 ||
    !isTrialUser ||
    loading
  ) {
    return null;
  }

  return (
    <OnboardingProgressFloaterPortal
      percentage={percentageComplete}
      onFloaterClick={redirectToOnboarding}
    />
  );
};

export default withErrorBoundary(withRouter(OnboardingProgressFloater));
